var $ = require('jquery');
var jQuery = $;
global.$ = $;
global.jQuery = jQuery;
require('bootstrap3');
var sclbasic = require('node-scl-basic');
var cca = require('../cca');
var Handlebars = require('handlebars');
var queryString = require('query-string');

var priceTpl     = require('../templates/tcf-price.tpl').default;
var epreuvesTpl  = require('../templates/tcf-epreuves.tpl').default;
var modalTpl     = require('../templates/modal_content.tpl').default;
var responseTpl  = require('../templates/response.tpl').default;
var toPaymentTpl = require('../templates/to_payment_msg.tpl').default;
var toFwdMessageTpl = require('../templates/fwd_msg.tpl').default;

////////////////////////////
/////////////////////////////////////////////////////
///////////////////////////////
//////////////////////////////////////////////////////////////
///////////////////////////
var config = require('../../config.public.live.json');
//////////

const Buffer = require('buffer/').Buffer;

// Types pour lesquels il n'y a pas de paiement immédiat — demande de devis uniquement
var TCF_DEVIS_ONLY_TYPES = ['tcf_canada', 'tcf_qc'];

var chosenService;
var currentFinalPrice = 0;
var clickedFlag = false;
var response_data = {};
var isDevisOnly = false; // true for tcf_canada / tcf_qc — no immediate payment

Handlebars.registerHelper('formatNumber', function(n) { return (+n).toFixed(2); });

function padDigits(n, d) { return Array(Math.max(d - String(n).length + 1, 0)).join(0) + n; }
Handlebars.registerHelper('formatDate', function(ts) {
    var d = new Date(ts * 1000);
    return padDigits(d.getUTCDate(),2)+'/'+padDigits(d.getUTCMonth()+1,2)+'/'+d.getUTCFullYear();
});

function run() {
    var query = queryString.parse(location.search);
    var examType = query.exam_type || '';

    isDevisOnly = TCF_DEVIS_ONLY_TYPES.indexOf(examType) !== -1;

    $( document ).ready(function () {
        $('.ajax_loading').hide();

        // Fill dummy data helper button (always present)
        $('<button type="button" style="position:fixed;bottom:12px;right:12px;z-index:9999;opacity:0.7;" class="btn btn-warning btn-sm">Fill test data</button>')
            .on('click', function() { fillDummyData(examType); })
            .appendTo('body');

        // Set exam_type hidden field
        $('[name=exam_type]').val(examType);

        // Load service + pricing data
        $.ajax({
            type: 'GET',
            url: BASE_PATH + '/proxy/services-list?pretty',
            contentType: 'text/plain',
            error: function() { alert('Erreur chargement données'); },
            success: function(data) {
                // Find the chosen service
                chosenService = (data.service_list.filter(function(s) {
                    return s.service_id === query.service_id;
                }))[0];

                if (!chosenService) {
                    $('#item').html('<p class="alert alert-danger">Session introuvable. Retournez à la page d\'accueil.</p>');
                    return;
                }

                // Prix = total du premier contrat associé au service (comme cambridge)
                var cdTemplate = chosenService.contrat_detail_template && chosenService.contrat_detail_template[0];
                if (!isDevisOnly && (!cdTemplate || !cdTemplate.total_ttc)) {
                    $('#item').html('<p class="alert alert-danger">Données tarifaires manquantes.</p>');
                    return;
                }

                var priceTmpl = Handlebars.compile(priceTpl);
                if (!isDevisOnly) {
                    currentFinalPrice = cdTemplate.total_ttc;
                    $('#item').append(priceTmpl({
                        showPrice: true,
                        label: query.label || chosenService.description,
                        total: currentFinalPrice
                    }));
                    $('#btn_price').text(currentFinalPrice.toFixed(2));
                } else {
                    $('#item').html('<div class="tcf-card" style="margin-top:20px;"><div class="tcf-card-body"><p class="tcf-info-text">Le tarif vous sera communiqué par notre équipe après réception de votre demande.</p></div></div>');
                    $('#item').append(priceTmpl({ showPrice: false }));
                }

                // Auto-fill AFTER the options section is in the DOM
                if (query.fillForm === 'dummydata') { fillDummyData(examType); }

                // Render épreuves template (hidden for Canada and IRN)
                if (examType !== 'tcf_canada' && examType !== 'tcf_irn' && examType !== 'tcf_civique' && examType !== 'tcf_tp') {
                    var epreuvesTmpl = Handlebars.compile(epreuvesTpl);
                    $('#epreuves_section').html(epreuvesTmpl({
                        isTp: examType === 'tcf_tp',
                        isQc: examType === 'tcf_qc'
                    }));
                }

                if (isDevisOnly) { $('#btn_price_wrap').hide(); }

                initBusinessLogic(examType);

                initForm(data);
            }
        });
    });
}

function initBusinessLogic(examType) {
    // pays_naissance → commune_naissance
    $('[name=pays_naissance]').on('change', function() {
        if ($(this).val() === 'France') {
            $('#commune_naissance_row').show();
            $('[name=commune_naissance]').attr('required', true);
        } else {
            $('#commune_naissance_row').hide();
            $('[name=commune_naissance]').removeAttr('required').val('');
        }
    });

    // has_code → ancien_code
    $('[name=has_code]').on('change', function() {
        if ($(this).val() === 'Oui') {
            $('#ancien_code_row').show();
            $('[name=ancien_code]').attr('required', true);
        } else {
            $('#ancien_code_row').hide();
            $('[name=ancien_code]').removeAttr('required').val('');
        }
    });

    // besoin_amenagement → detail + file
    $('[name=besoin_amenagement]').on('change', function() {
        if ($(this).val() === 'Oui') {
            $('#besoin_detail_row').show();
        } else {
            $('#besoin_detail_row').hide();
            $('[name=besoin_detail]').val('');
            $('[name=certificat_medical]').val('');
        }
    });

    // exam_type: Canada shows passport, IRN/Canada hide epreuves (already done via template)
    if (examType === 'tcf_canada') {
        $('#passeport_row').show();
        $('[name=num_passeport]').attr('required', true);
    }
}

// Options complémentaires cochées — capture seule, aucun effet sur le prix payé
function collectChosenOptions() {
    var options = {};
    $('.tcf_option_check:checked').each(function() {
        options[$(this).data('option')] = 1;
    });
    return options;
}

var templateModal = Handlebars.compile(modalTpl);
function validateForm(formData) {
    var wrong_input = false;
    var messages = [];

    var user = formData[0] && formData[0].new_user && formData[0].new_user[0];
    // Merge all custom_middle_data_scl_json entries — retrieveFormObject may split across multiple indices
    var midArray = (formData[0] && formData[0].custom_middle_data_scl_json) || [];
    var mid = Object.assign.apply(Object, [{}].concat(midArray));

    if (!user || !user.nom)          { $('[name=nom]').addClass('is-invalid');           wrong_input = true; messages.push('Nom'); }
    if (!user || !user.prenom)       { $('[name=prenom]').addClass('is-invalid');         wrong_input = true; messages.push('Prénom'); }
    if (!user || !user.email)        { $('[name=email]').addClass('is-invalid');          wrong_input = true; messages.push('Email'); }
    if (!user || !user.tel1)         { $('[name=tel1]').addClass('is-invalid');           wrong_input = true; messages.push('Téléphone'); }
    if ($('[name=dob]').length && (!user || !user.dob))                   { $('[name=dob]').addClass('is-invalid');            wrong_input = true; messages.push('Date de naissance'); }
    if ($('[name=pays_naissance]').length && (!user || !user.pays_naissance)){ $('[name=pays_naissance]').addClass('is-invalid'); wrong_input = true; messages.push('Pays de naissance'); }
    if ($('[name=nationalite]').length && (!user || !user.nationalite))   { $('[name=nationalite]').addClass('is-invalid');    wrong_input = true; messages.push('Nationalité'); }

    if ($('#commune_naissance_row').is(':visible') && (!user || !user.commune_naissance)) {
        $('[name=commune_naissance]').addClass('is-invalid');
        wrong_input = true; messages.push('Commune de naissance');
    }
    if ($('[name=code_preinscription_fei]').length && (!mid || !mid.code_preinscription_fei)) {
        $('[name=code_preinscription_fei]').addClass('is-invalid');
        wrong_input = true; messages.push('Identifiant de connexion FEI');
    }
    if ($('[name=motif]').length && (!mid || !mid.motif)) {
        $('[name=motif]').addClass('is-invalid');
        wrong_input = true; messages.push("Motif d'inscription");
    }
    if ($('#ancien_code_row').is(':visible') && (!mid || !mid.ancien_code)) {
        $('[name=ancien_code]').addClass('is-invalid');
        wrong_input = true; messages.push('Ancien code candidat');
    }
    if ($('#passeport_row').is(':visible') && (!mid || !mid.num_passeport)) {
        $('[name=num_passeport]').addClass('is-invalid');
        wrong_input = true; messages.push('Numéro de passeport');
    }
    if (!$('[name=gdpr1]').prop('checked')) { wrong_input = true; messages.push('Consentement RGPD (1)'); }
    if (!$('[name=gdpr2]').prop('checked')) { wrong_input = true; messages.push('Consentement RGPD (2)'); }

    if (wrong_input) {
        $('#missingInputModal .modal-body').html(templateModal({ wrong_input: messages }));
        $('#missingInputModal').modal('show');
        return false;
    }
    return true;
}

function enrichFormData(formData) {
    // Items repris tels quels du contrat template du service (comme cambridge)
    var items = (chosenService.contrat_detail_template[0].item || []).map(function(i) {
        return {
            facturation_id: i.facturation_id,
            produit_info_id: i.produit_info_id,
            quantite: i.quantite,
            code_tva: i.code_tva,
            ht: i.ht,
            taux: i.taux,
            ttc: i.ttc
        };
    });

    formData[0].contrat_detail = [{
        total_ttc: currentFinalPrice,
        service: [{ service_id: chosenService.service_id }],
        item: items
    }];
    return formData;
}

function initForm(data) {
    $('button#tcfsignup').click(function(e) {
        if (clickedFlag) return;
        clickedFlag = true;
        e.preventDefault();

        var formdata = sclbasic.restFormSubmit.retrieveFormObject($('form#tcfform'));
        if (!validateForm(formdata)) { clickedFlag = false; return; }
        if (!isDevisOnly) { formdata = enrichFormData(formdata); }

        // Options complémentaires → custom_middle_data_scl_json (reprises côté core
        // dans contrat_user_xtra_scl_json, sans effet sur le montant payé).
        // Forme liste-d'objet [{...}] : les maps nues cassent cleanInputData côté core
        if (!formdata[0].custom_middle_data_scl_json) { formdata[0].custom_middle_data_scl_json = [{}]; }
        formdata[0].custom_middle_data_scl_json[0].options_complementaires = [collectChosenOptions()];

        response_data.nom     = formdata[0].new_user[0].nom;
        response_data.prenom  = formdata[0].new_user[0].prenom;
        response_data.service = chosenService;
        response_data.amount  = currentFinalPrice;

        sendForm({ scl: formdata, amount: currentFinalPrice, service: chosenService, devis_only: isDevisOnly });
    });
}

var templateResponse   = Handlebars.compile(responseTpl);
var templateToPayment  = Handlebars.compile(toPaymentTpl);
var templateToFwdMsg   = Handlebars.compile(toFwdMessageTpl);

function sendForm(data) {
    $('.ajax_loading').show();
    $.ajax({
        dataType: null,
        contentType: 'application/json',
        method: 'POST',
        url: BASE_PATH + '/payment/send-tcf',
        data: JSON.stringify(data),
        mimeType: 'application/json',
        success: function(server_res) {
            $('.ajax_loading').fadeOut();
            response_data.server = server_res;
            if (server_res.devis_only) {
                // Pas de paiement — afficher confirmation de demande
                $('#content').html(
                    '<div class="tcf-card" style="margin-top:20px;">' +
                    '<div class="tcf-card-header">✅ Demande enregistrée</div>' +
                    '<div class="tcf-card-body">' +
                    '<p class="tcf-info-text">Votre demande a bien été enregistrée. Notre équipe vous contactera dans les meilleurs délais pour vous communiquer le tarif et confirmer votre inscription.</p>' +
                    '</div></div>'
                );
            } else if (server_res.scl && server_res.scl.contrat_detail) {
                setTimeout(function() {
                    var params = {
                        skins: 'cca',
                        experience: 'tcf',
                        account_id: server_res.scl.contrat_detail[0].account_id,
                        contrat_list: server_res.scl.contrat_detail[0].contrat_detail_id,
                        fwd_pay: Buffer.from(JSON.stringify({
                            toto: 1,
                            message_html: templateToFwdMsg(response_data)
                        }), 'utf8').toString('base64')
                    };
                    window.location.href = config.payment_url + '?' + queryString.stringify(params);
                }, 3000);
                response_data.contrat_valid = true;
                $('#content').html(templateToPayment(response_data));
            } else {
                $('#content').html(templateToPayment(response_data));
            }
        },
        error: function() {
            $('.ajax_loading').fadeOut();
            $('#content').html("Il y a une erreur. Merci d'envoyer une capture d'écran sur bug@groupeset.com");
        }
    });
}

function fillDummyData(examType) {
    $('[name=nom]').val('DUPONT');
    $('[name=prenom]').val('Marie');
    $('[name=email]').val('marie.dupont@test.com');
    $('[name=tel1]').val('0612345678');
    $('[name=dob]').val('15/06/1990');
    $('[name=sexe]').val('Madame');
    $('[name=pays_naissance]').val('France').trigger('change');
    $('[name=commune_naissance]').val('Nice');
    $('[name=nationalite]').val('Française');
    $('[name=langue_usuelle]').val('Français');
    $('[name=has_code]').filter('[value=Non]').prop('checked', true).trigger('change');
    $('[name=besoin_amenagement]').filter('[value=Non]').prop('checked', true).trigger('change');
    if (examType === 'tcf_canada') { $('[name=num_passeport]').val('12AB34567'); }
    if (examType === 'tcf_civique') { $('[name=code_preinscription_fei]').val('FEI123456'); }
    else { $('[name=motif]').val('Visa / immigration'); }
    // Tick one option complémentaire
    $('#option_diagnostic').prop('checked', true);
    // GDPR consent
    $('[name=gdpr1]').prop('checked', true);
    $('[name=gdpr2]').prop('checked', true);
}

module.exports = { run: run };
